import { queryOptions } from "@tanstack/react-query";
import { PaginationParams } from "@vixi/router";
import { Paginated, RequestedFeature } from "@vixi/types";
import { api, endpoints } from "@vixi/api";

export const myFeaturesQueryOptions = (params: PaginationParams) =>
  queryOptions({
    queryKey: ["myFeatures", params],
    queryFn: async () => {
      const { pageNumber = 1, pageSize = 1000 } = params;
      const response = await api.get<Paginated<RequestedFeature>>(endpoints.getMyFeatures, {
        params: {
          ...params,
          pageNumber,
          pageSize,
        },
      });

      return response.data;
    },
  });
